export const signInTitleText = {
  title_line1:"Feedback is a culture;",
  title_line2: "not a formality.",
  title_line3:"Let us embrace it!"
}
